var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('my-popconfirm',{attrs:{"title":_vm.title,"placement":_vm.placement},on:{"onConfirm":_vm.onConfirm}},[_c('ux-button',{attrs:{"slot":"reference","type":"danger","text":""},slot:"reference"},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }